import { render, staticRenderFns } from "./MessageWidget.vue?vue&type=template&id=79dad51c&scoped=true"
import script from "./MessageWidget.vue?vue&type=script&lang=js"
export * from "./MessageWidget.vue?vue&type=script&lang=js"
import style0 from "./MessageWidget.vue?vue&type=style&index=0&id=79dad51c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dad51c",
  null
  
)

export default component.exports